module.exports = __webpack_public_path__ + "static/Sonyax52-49d27ba385ccf8059f23dc4054792a20.png";